export default __webpack_public_path__ + "static/media/tutorial-set-policies-2.8235c812.png";